angular.module('am4').service('formatStrengthService', function(CONVERSIONS) {

    var fullUnits = {
            metric: 'KILOGRAM',
            imperial: 'POUND'
        },
        abrevUnits = {
            metric: 'KG',
            imperial: 'LBS'
        },
        fullPhrase = {
            metric: 'N_KILOGRAMS',
            imperial: 'N_POUND'
        },
        abrevPhrase = {
            metric: 'N_KG',
            imperial: 'N_LBS'
        },
        conversion = {
            poundsToKilograms: function(weight) { return weight; },
            kilogramsToPounds: function(weight) { return weight * CONVERSIONS.KG_CONSTANT; }
        };

    return {

        /**
         * @funtion formatStrength
         * @description Extends an object with two properties, totalWeight, and weightUnit
         * which describe that objects weight and preferred unit.
         * @param  {Object}  distObj           Object to be extended with totalWeight and weightUnit
         * @param  {String}  unitPreference    User's unit preference
         * @param  {String}  modality          Machine modality the weight is for, determines steps vs mi/km
         * @param  {Boolean} longUnits         True for full weight units, false for abbreviations
         * @param  {String}  weight             Param name for steps in distObj, defaults to 'total_weight'
         * @return {Object}                    Updated weight object
         */
        formatStrength: function(distObj, unitPreference, longUnits, modality) {
            var normalWeightConversion = unitPreference === 'metric' ? conversion.poundsToKilograms : conversion.kilogramsToPounds,
                isStrength = modality === 'strength',
                weight = 'total_weight',
                weightForHistoryTab = 'history_weight';

            if (!distObj[weight]) {
                distObj[weight] = 0;
            } else if (!distObj[weightForHistoryTab]) {
                distObj[weightForHistoryTab] = 0;
            }

            if (isStrength) {
                distObj.weightUnit = 'POUND';
                distObj.weightPhrase = 'N_POUND';
            } else {
                distObj.weightUnit = longUnits ? fullUnits[unitPreference] : abrevUnits[unitPreference];
                distObj.weightPhrase = longUnits ? fullPhrase[unitPreference] : abrevPhrase[unitPreference];
            }

            distObj.totalWeight = normalWeightConversion(+distObj[weight]);
            distObj.totalWeightForHistoryTab = normalWeightConversion(+distObj[weightForHistoryTab]);

            return distObj;
        },

        /**
         * @funtion formatStrengthDelta
         * @description Extends an object with two properties, totalWeight, and weightUnit
         * which describe that objects weight and preferred unit
         *
         * Accepts `distObj` with 'accumulated_steps_delta' and 'accumulated_miles_100_delta' properties
         *
         * @param  {String}  unit preference   User's unit preference
         * @param  {Object}  distObj           Object to be extended with totalWeight, weightPhrase, and weightUnit
         * @param  {Boolean} longUnits         True for full weight units, false for abbreviations
         * @return {Object}                    Updated weight object
         */
        formatStrengthDelta: function(distObj, unitPreference, modality, longUnits) {
            return this.formatStrength(distObj, unitPreference, modality, longUnits);
        },

        /**
         * @funtion formatStrengthTotal
         * @description Extends an object with two properties, totalWeight, and weightUnit
         * which describe that objects weight and preferred unit
         *
         * Accepts `distObj` with 'total_steps' and 'total_miles_100' properties
         *
         * @param  {String}  unit preference   User's unit preference
         * @param  {Object}  distObj           Object to be extended with totalWeight, weightUnit and weightUnit
         * @param  {Boolean} longUnits         True for full weight units, false for abbreviations
         * @return {Object}                    Updated weight object
         */
        formatStrengthTotal: function(distObj, unitPreference, modality, longUnits) {
            return this.formatStrength(distObj, unitPreference, modality, longUnits, 'total_weight');
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/formatStrength.js